import { render, staticRenderFns } from "./ProjectRoles.vue?vue&type=template&id=390787c0&lang=pug"
import script from "./ProjectRoles.vue?vue&type=script&lang=js"
export * from "./ProjectRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports